const { __ } = wp.i18n;
/**
 * Dropdown block
 *
 * @since 3.2.13
 */
export const metadata = {
  name: __("GA map", "uipress-pro"),
  moduleName: "uip-google-analytics-map",
  description: __("Outputs your visitor data to a interactive map", "uipress-pro"),
  category: __("Analytics", "uipress-pro"),
  group: "analytics",
  icon: "map",
};
